import {
    Accordion,
    AccordionContent,
    AccordionHeader,
} from '@eventbrite/eds-accordion';
import React from 'react';
import { FaqContent, FaqWrapper, HeaderContent } from './Faq.styles';
import { FaqWidget } from './types';

interface Props {
    data: FaqWidget;
}

export const Faq: React.FC<Props> = ({ data }) => {
    return (
        <FaqWrapper>
            {data.faqs?.map(({ question, answer }, index) => (
                <Accordion key={index}>
                    <AccordionHeader>
                        <HeaderContent>{question}</HeaderContent>
                    </AccordionHeader>
                    <AccordionContent>
                        <FaqContent>{answer}</FaqContent>
                    </AccordionContent>
                </Accordion>
            ))}
        </FaqWrapper>
    );
};
